import { object, string } from "yup";

export const getValidationSchema = (defaultValue?: string) => {
  const validationSchema = object().shape({
    recipientEmail: string()
      .email("Invalid email.")
      .trim()
      .required("Email can't be blank.")
  });

  return {
    validationSchema,
    defaultValues: { recipientEmail: defaultValue || "" }
  };
};
